/* eslint-disable import/prefer-default-export */
export const VISITED_URLS_STORAGE_KEY = 'visitedUrls';
